import React, { Component } from 'react';
export default class ContentContainer extends Component {
    render() {
        const { style = {}, className } = this.props;
        return (<div style={Object.assign({ margin: '20px 70px', padding: 25, backgroundColor: '#fff' }, style)} className={className}>
            {this.props.children}
        </div>);
    }
}
